import { combineReducers } from 'redux';

import { IAction } from '../../../types';
import {
    GET_PERFEED_FEEDBACKS_SUCCESS,
    PERFEED_FEEDBACKS_CHANGE_PAGE,
} from '../../../actions/PerfeedActions';

const mockList = [
    {
        id: 1,
        name: 'Amelia Smith',
        project: 'meeting PM',
        date: '2019-07-18T14:20',
        status: 'edit',
    },
    {
        id: 2,
        name: 'Emily Roberts',
        project: 'Project',
        date: '2019-07-18T14:20',
        status: 'edit',
    },
    {
        id: 3,
        name: 'Emily Roberts',
        project: 'Sales meeting',
        date: '2019-07-18T14:20',
        status: 'edit',
    },
];

const items = (state = mockList, action: IAction) => {
    switch (action.type) {
        case GET_PERFEED_FEEDBACKS_SUCCESS:
            return state; // return action.payload as [];
        default:
            return state;
    }
};

const paginationState = {
    page: 0,
    pages: 0,
    totalElements: 0,
    start: 0,
    end: 0,
};

const pagination = (state = paginationState, action: IAction) => {
    switch (action.type) {
        case GET_PERFEED_FEEDBACKS_SUCCESS:
            return Object.assign({}, state, {
                pages: 10,
                totalElements: 133,
                start: state.page * 20,
                end: state.page * 20 + 20,
            }); // return action.payload.pagination;
        case PERFEED_FEEDBACKS_CHANGE_PAGE:
            return Object.assign({}, state, { page: action.payload as number });
        default:
            return state;
    }
};

const list = combineReducers({ items, pagination });

export default combineReducers({ list });
